import { render, staticRenderFns } from "./ExamConfirmDialog.vue?vue&type=template&id=b22f0552&scoped=true&"
import script from "./ExamConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./ExamConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExamConfirmDialog.vue?vue&type=style&index=0&id=b22f0552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22f0552",
  null
  
)

component.options.__file = "ExamConfirmDialog.vue"
export default component.exports